import { render } from "./ReturnSetting.vue?vue&type=template&id=021802c7&scoped=true"
import script from "@/assets/js/return.js?vue&type=script&lang=js&external"
export * from "@/assets/js/return.js?vue&type=script&lang=js&external"

import "@/assets/css/return.css?vue&type=style&index=0&id=021802c7&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021802c7"]])

export default __exports__